import styled from '@emotion/styled';
import { rem } from '../../styles/theme/layout';
import { AppTheme } from '../../styles/theme';

export default styled.input`
  &:checked,
  &:not(:checked) {
    position: absolute;
    opacity: 0;
    width: 18px;
    height: 18px;
    z-index: 1;
    cursor: pointer;
  }

  &:checked + span,
  &:not(:checked) + span {
    position: relative;
    padding-left: ${rem(30)};
    line-height: 1.5;
    display: inline-block;
  }

  &:checked + span::before,
  &:not(:checked) + span::before {
    transition: all 200ms ease-out;
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 20px;
    height: 20px;
    border-radius: ${({ theme }) => (theme as AppTheme).radii.normal};
    background: #fff;
    box-shadow: 0px 1px 3px #cfdde6;
    border: 1px solid transparent;
    box-sizing: border-box;
  }

  &:checked + span::after,
  &:not(:checked) + span::after {
    content: '';
    width: 20px;
    height: 20px;
    position: absolute;
    top: 0;
    left: 0;
    background-image: url("data:image/svg+xml,%3Csvg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='17' height='17' rx='3' fill='%232D2D2D'/%3E%3Cpath d='M3.5 8.55882L6.94118 12L13.4412 5.5' stroke='white' stroke-width='2' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: ${({ theme }) => (theme as AppTheme).radii.normal};
    transition: all 0.2s ease;
  }

  &:not(:checked) + span::after {
    opacity: 0;
    transform: scale(0);
  }

  &:checked + span::after {
    opacity: 1;
    transform: scale(1);
  }

  &[aria-invalid='true'] + span::before {
    border-color: ${({ theme }) => (theme as AppTheme).colors.red};
  }

  &:focus:not(:hover) + span::before {
    box-shadow: 0 1px 3px #b8c4cc;
    border-color: ${({ theme }) => (theme as AppTheme).colors.darkGray};
  }
`;
